import { render, staticRenderFns } from "./AuthCode.vue?vue&type=template&id=a033553e&scoped=true&"
import script from "./AuthCode.vue?vue&type=script&lang=js&"
export * from "./AuthCode.vue?vue&type=script&lang=js&"
import style0 from "./AuthCode.vue?vue&type=style&index=0&id=a033553e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a033553e",
  null
  
)

export default component.exports